var CollectionView = require('views/base/collection-view');
var InputItemView = require('views/block/input/input-item-view');

var InputCollectionView = CollectionView.extend({
  template: require('./templates/input-collection'),
  itemView: InputItemView,
  listSelector: '.input-list',
  autoRender: true
});

module.exports = InputCollectionView;
